<template>
  <modal name="staffDetailModal" :width="443" :height="'auto'"
         :scrollable="true" :pivotX="1.0" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose">
    <div class="staffDetailWrapper">
      <div class="row">
        <div class="col-md-6">
          <div class="staff-name">{{firstName}} {{lastName}}</div>
        </div>
        <div class="col-md-6">
          <div class="modal-close-img" @click="hideModal()">
            <div class="icon-close"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="label">FIRST NAME</div>
          <div class="information">{{firstName}}</div>
        </div>
        <div class="col-md-6">
          <div class="label">LAST NAME</div>
          <div class="information">{{lastName}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="label">EMAIL</div>
          <div class="information">{{email}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="label">PHONE NUMBER</div>
          <div class="">
            <the-mask mask="(###) ###-####" v-model="phone" class="information input-staff"
                      :masked="isDisable"
                      :disabled="isDisable"/></div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="label">ROLES</div>
          <div class="information text-role">{{role}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="label">HOURLY RATE</div>
          <div class="information text-role">&#36; {{payRates}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="label">ADDRESS</div>
          <div class="information text-role">{{address}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="label">EVENT ({{totalEvents}})</div>
          <div class="event-link" v-for="event in eventList" @click="goToEventDetail(event)">
            {{event.eventName}}
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import {TheMask} from '../../utils/vue-the-mask';
  // import constant from '../../../_consts';

  export default {
    name: '',
    components: {
      TheMask
    },
    props: {
    },
    data () {
      return {
        events: {
          type: Object,
          default: {}
        },
        isDisable: true,
        firstName: '',
        lastName: '',
        phone: '',
        role: '',
        eventList: {},
        totalEvents: 0,
        email: '',
        payRates: 0,
        address: ''
      }
    },
    methods: {
      goToEventDetail (event) {
        let eventId = event.id;
        this.setIsLoading(true); // set loading = true
        localStorage.setItem('isFromStaff', true);
        this.$modal.hide('staffDetailModal');
        this.$router.push({name: 'ManageEventDetail', params: {eventId: eventId}});
      },
      hideModal () {
        this.$modal.hide('staffDetailModal');
      },
      beforeOpen (detail) {
        let item = detail.params;
        this.firstName = item.firstName;
        this.lastName = item.lastName;
        this.phone = item.phone;
        this.role = item.role;
        this.eventList = item.eventList;
        this.totalEvents = item.totalEvents;
        this.email = item.email;
        this.payRates = item.payRates;
        this.address = item.address;
      },
      beforeClose () {
      },
      ...mapActions({
      }),
      ...mapMutations({
        setIsLoading: 'MUTATION_SET_IS_LOADING'
      })
    },
    computed: {
      ...mapGetters({
      })
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';
  .staffDetailWrapper {
    background-color: #FFFFFF;
    left: 70%;
    height: 100vh;
    margin: 24px;
    .staff-name {
      color: #1D1D1D;
      font-family: "Open Sans",serif;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0.2px;
      line-height: 32px;
    }
    .label {
      color: #424242;
      font-family: "Open Sans",serif;
      font-size: 12px;
      line-height: 16px;
      margin-top: 24px;
    }

    .text-role{
      text-transform: capitalize;
    }

    .information {
      color: #1D1D1D;
      font-family: "Open Sans",serif;
      font-size: 16px;
      line-height: 24px;
      margin-top: 8px;
      &.input-staff {
        border: none;

        &:disabled{
          background-color: @white;
          color: #1D1D1D;
        }
      }
    }
    .event-link {
      color: #00A4D6;
      font-family: "Open Sans",serif;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 0.1px;
      line-height: 20px;
      margin-top: 16px;
      cursor: pointer;
    }
    .modal-close-img {
      float: right;
      .icon-close {
        margin: 1.5px 1.5px;
        width: 27px;
        height: 27px;
        // color: @grey-3;
        // background-color: @grey-3;
        // -webkit-mask: url('../../../../static/img/action-close.svg') no-repeat center;
        // mask: url('../../../../static/img/action-close.svg') no-repeat center;
        background: url('../../../../static/img/action-close-grey.svg');
        // @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        // }

        &:hover{
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// StaffDetailModal.vue?e00f82f8